import Controller from '../herbal_tea_product_controller'
export default Controller